import { Component } from '@angular/core';
import { LaunchpadUser } from '../../../models/launchpad-user';

@Component({
    selector: 'app-user-orgs-slideout',
    templateUrl: './user-orgs-slideout.component.html',
    styleUrls: ['../../user-slideout.component.sass'],
    standalone: false
})
export class UserOrgsSlideoutComponent {

  loading: boolean = true;
  user: LaunchpadUser | null = null;

}
